<template>
	<div class="container-fluid">
		  <div class="m-2">
      		<div class="alert alert-primary">
        		<div class="h4 text-center">
          			<linkto :link="'/'"/>
          			Érdeklődő módosítás
        		</div>
      		</div>
    	</div>
    	<div class="row d-flex justify-content-center align-items-center">
          <inquiring-data
  				    :change="true"
  				    :inquiring="true"
            	:user="$store.getters.user.nev"
            	:id="$route.params.id"
          >
          </inquiring-data>
  		</div>
	</div>
</template>
<script type="text/javascript">
import inquiringData from '../customers/customer_data'
export default {
    components: {
		    inquiringData
    },

    computed: {
        datum(){
		    return this.$moment().format('YYYY-MM-DD')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/inquiring/edit.vue